module.exports = __webpack_public_path__ + "static/img/14.b1704c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/zh/14.png
// module id = v4f1
// module chunks = 0